module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_16.png?7c6804c918af154079b774d44bbf19f0";